import Vue from 'vue'
import Router from 'vue-router'
import AccountsView from './views/AccountsView.vue'
import DashboardView from './views/DashboardView.vue'
import PartiesView from './views/PartiesView.vue'
import CashflowSetupView from './views/CashflowSetupView.vue'
import CashflowReportDefinitionsView from './views/CashflowReportDefinitionsView.vue'
import CashflowReportView from './views/CashflowReportView.vue'
import CashflowHeatMapView from './views/CashflowHeatMapView.vue'
import OperationDefinitionsView from './views/OperationDefinitionsView.vue'
import OperationLinkDefinitionsView from './views/OperationLinkDefinitionsView.vue'
import OperationDefinitionGroupsView from './views/OperationDefinitionGroupsView.vue'
import CashEventGenerationScriptsView from './views/CashEventGenerationScriptsView.vue'
import CurrenciesView from './views/CurrenciesView.vue'
import PartyRoleTypesView from "./views/PartyRoleTypesView.vue";
import PaymentBatchesView from "./views/PaymentBatchesView.vue";
import PaymentBatchTemplatesView from "./views/PaymentBatchTemplatesView.vue";
import PaymentsView from './views/PaymentsView.vue'
import ImportFilesView from "./views/ImportFilesView.vue";
import ScriptDefinitionsView from "./views/ScriptDefinitionsView.vue"
import ImportMappingsView from "./views/ImportMappingsView.vue";
import ProcessesView from "./views/ProcessesView.vue";
import CashflowView from "./views/CashflowView";
import PaymentFactoryView from "./views/PaymentFactoryView";
import OperationsListingView from "./views/OperationsListingView";
import OperationsView from "./views/OperationsView";
import BankingView from "./views/BankingView";
import PartyManagementView from "./views/PartyManagementView";
import MarketView from "./views/MarketView";
import AdministrationView from "./views/AdministrationView";
import ProcessingView from "./views/ProcessingView";
import UsersView from "./views/UsersView";
import ProcessingScheduledJobsView from "./views/ProcessingScheduledJobsView";
import ReconciliationView from "./views/ReconciliationView";
import SingleDashboardView from "./views/SingleDashboardView";
import SingleDashboardEditView from "./views/SingleDashboardEditView";
import CashEventsView from "./views/CashEventsView";
import CashEffectsView from "./views/CashEffectsView";
import AccountBalancesBlotterView from "./views/AccountBalancesBlotterView";
import CreditRiskView from "./views/CreditRiskView"
import AccountBalancesView from "./views/AccountBalancesView";
import AccountBalanceItemsView from "./views/AccountBalanceItemsView";
import ReconciliationItemsView from "./views/ReconciliationItemsView";
import SecurityGroupsView from "./views/SecurityGroupsView";
import OperationLinksView from "./views/OperationLinksView";
import ExchangeRatesView from "@/views/ExchangeRatesView";
import InterestRatesView from "@/views/InterestRatesView";
import AccountTimeLinesView from "@/views/AccountTimeLinesView";
import UserSettingsView from "@/views/UserSettingsView.vue"
import VolatilitiesView from "@/views/VolatilitiesView";
import VarCalculationView from "@/views/VarCalculationView";
import VarCalculationDefinitionsView from "@/views/VarCalculationDefinitionsView";
import ComparisonView from "@/views/ComparisonView";

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/',
            redirect: '/dashboards/view/home'
        },
        {
            path: '/dashboards',
            name: 'dashboards',
            component: DashboardView,
            redirect: '/dashboards/view/home',
            meta: {
                title: "Dashboard"
            },
            children: [
                {
                    component: SingleDashboardEditView,
                    path: "edit/:dashboardId",
                    meta: {
                        title: "Dashboard editation"
                    }
                },
                {
                    component: SingleDashboardView,
                    path: "view/:dashboardId",
                    meta: {
                        title: "Dashboard"
                    }

                }
            ]
        },
        {
            path: '/user-settings',
            component: UserSettingsView,
            meta: {
                title: "User settings"
            }
        },
        {
            path: '/banking',
            name: 'banking',
            component: BankingView,
            children: [
                {
                    path: 'accounts',
                    component: AccountsView,
                    props: (route) => ({internal: route.query.type !== 'external'}),
                    meta: {
                        title: "Accounts"
                    }
                },
                {
                    path: 'reconciliation-workbench',
                    component: ReconciliationView,
                    meta: {
                        title: "Reconciliation"
                    }
                },
                {
                    path: 'reconciliation-items',
                    component: ReconciliationItemsView,
                    meta: {
                        title: "Reconciliation items"
                    }
                },
                {
                    path: '/banking/account-timelines',
                    component: AccountTimeLinesView,
                    meta: {
                        title: "Account timelines"
                    }
                },
                {
                    path: '/banking/account-balances',
                    component: AccountBalancesView,
                    meta: {
                        title: "Account balances"
                    }
                },
                {
                    path: '/banking/account-balance-items',
                    component: AccountBalanceItemsView,
                    meta: {
                        title: "Account balance items"
                    }
                },
                {
                    path: 'account-balances-blotter',
                    component: AccountBalancesBlotterView,
                    meta: {
                        title: "Account balances blotter"
                    }
                }
            ]
        },
        {
            path: '/operations',
            name: 'operations',
            component: OperationsView,
            children: [
                {
                    path: 'by-definition/:operationType',
                    name: 'operationsByDefinition',
                    component: OperationsListingView,
                    meta: {
                        title: "Operations"
                    }
                },
            ]


        },
        {
            path: '/parties',
            name: 'partyManagement',
            component: PartyManagementView,
            children: [
                {
                    path: '',
                    name: 'parties',
                    component: PartiesView,
                    meta: {
                        title: "Parties"
                    }
                },
                {
                    path: 'credit-risk',
                    name: 'credit-risk',
                    component: CreditRiskView,
                    meta: {
                        title: "Credit risk management"
                    }
                }
            ]
        },
        {
            path: '/cash-flow',
            component: CashflowView,
            children: [
                {
                    path: "definitions",
                    component: CashflowReportDefinitionsView
                },
                {
                    path: 'report/:report',
                    component: CashflowReportView,
                },
                {
                    path: 'heat/:report',
                    component: CashflowHeatMapView
                },
                {
                    path: 'cash-events',
                    component: CashEventsView
                },
                {
                    path: 'cash-effects',
                    component: CashEffectsView
                }
            ]
        },
        {
            path: '/reporting',
            component: VarCalculationView,
            children: [
                {
                    path: "definitions",
                    component: VarCalculationDefinitionsView
                },
                {
                    path: "comparison/:id",
                    component: ComparisonView
                },
            ]
        },
        {
            path: '/administration',
            name: 'administration',
            component: AdministrationView,
            children: [
                {
                    path: 'cash-event-generation-scripts',
                    name: 'cashEventGenerationScripts',
                    component: CashEventGenerationScriptsView,
                    meta: {
                        title: "Cash-event generation scripts"
                    }
                },
                {
                    path: 'operation-definitions',
                    name: 'operationDefinitions',
                    component: OperationDefinitionsView,
                    meta: {
                        title: "Operation definitions"
                    }
                },
                {
                    path: 'operation-definition-groups',
                    name: 'operationDefinitionGroups',
                    component: OperationDefinitionGroupsView,
                    meta: {
                        title: "Operation definition groups"
                    }
                },
                {
                    path: 'operation-links',
                    name: 'operationLinks',
                    component: OperationLinksView,
                    meta: {
                        title: "Operation links"
                    }
                },
                {
                    path: 'operation-link-definitions',
                    name: 'operationLinkDefinitions',
                    component: OperationLinkDefinitionsView,
                    meta: {
                        title: "Operation link definitions"
                    }
                },
                {
                    path: 'cash-flow-setup',
                    name: 'cashflowSetup',
                    component: CashflowSetupView,
                    meta: {
                        title: "Cashflow setup"
                    }
                },
                {
                    path: 'party-role-types',
                    name: 'partyRoleTypes',
                    component: PartyRoleTypesView,
                    meta: {
                        title: "Party role types"
                    }
                },
                {
                    path: 'users',
                    name: 'users',
                    component: UsersView,
                    meta: {
                        title: "Users"
                    }
                },
                {
                    path: 'security-groups',
                    name: 'security-groups',
                    component: SecurityGroupsView,
                    meta: {
                        title: "Security groups"
                    }
                }
            ]
        },
        {
            path: '/market',
            name: 'market',
            component: MarketView,
            meta: {
                title: "Markets"
            },
            children: [
                {
                    path: "currencies",
                    component: CurrenciesView
                },
                {
                    path: "exchange-rates",
                    component: ExchangeRatesView
                },
                {
                    path: "interest-rates",
                    component: InterestRatesView
                },
                {
                    path: "volatilities",
                    component: VolatilitiesView
                },

            ]
        },
        {
            path: '/payment-factory',
            name: 'paymentFactory',
            component: PaymentFactoryView,
            children: [
                {
                    path: 'batches',
                    name: 'paymentBatches',
                    component: PaymentBatchesView,
                    meta: {
                        title: "Payment batches"
                    }
                },
                {
                    path: 'batch-templates',
                    name: 'paymentBatchTemplates',
                    component: PaymentBatchTemplatesView,
                    meta: {
                        title: "Payment batch templates"
                    }
                },
                {
                    path: 'payments',
                    name: 'payments',
                    component: PaymentsView,
                    meta: {
                        title: "Payments"
                    }
                }
            ]
        },
      {
        name: 'processing',
        path: '/processing',
        component: ProcessingView,
        children: [
          {
            path: 'files',
            name: 'importFiles',
            component: ImportFilesView,
            meta: {
              title: "Import files"
            }
          },
          {
            path: 'definitions',
            name: 'importDefinitions',
            component: ScriptDefinitionsView,
            meta: {
              title: "Script definitions"
            }
          },
          {
            path: 'processes',
            name: 'importProcesses',
            component: ProcessesView,
            meta: {
              title: "Import processes"
            }
          },
          {
            path: 'mappings',
            name: 'importMappings',
            component: ImportMappingsView,
            meta: {
              title: "Import mappings"
            }
          },
            {
                path: 'scheduled-jobs',
                name: 'scheduledJobs',
                component: ProcessingScheduledJobsView,
                meta: {
                    title: "Scheduled jobs"
                }
            }
        ]
      }
        // {
        //   path: '/about',
        //   name: 'about',
        //   // route level code-splitting
        //   // this generates a separate chunk (about.[hash].js) for this route
        //   // which is lazy-loaded when the route is visited.
        //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        // }
    ]
});

router.beforeEach((to, from, next) => {
    document.title = `OpenTreasury - ${to.meta.title ?? "Treasury"}`;
    next()
});

export default router;
